import type { TFunction } from "i18next";
import type {
  DocumentDetailsRelease,
  DocumentReleaseSummary,
} from "~/api/types";
import { DocumentArtifactStatus, type ReviewPeriod } from "~/config/types";

export function getReviewPeriodLabel(
  period: string | null,
  t: TFunction,
): string | null {
  if (!period) return null;
  const labels: Record<ReviewPeriod, string> = {
    "3 MONTH": t(($) => $.commons.document.reviewPeriods.every3months),
    "6 MONTH": t(($) => $.commons.document.reviewPeriods.every6months),
    "1 YEAR": t(($) => $.commons.document.reviewPeriods.yearly),
    "3 YEAR": t(($) => $.commons.document.reviewPeriods.every3years),
    "5 YEAR": t(($) => $.commons.document.reviewPeriods.every5years),
  };
  return labels[period as ReviewPeriod] ?? period;
}

export function getPreviousRelease(
  selectedRelease: DocumentDetailsRelease,
  releases: DocumentDetailsRelease[],
): {
  release: DocumentDetailsRelease;
  releaseNumber: number;
} | null {
  const currentIndex = releases.findIndex(
    (release) => release.id === selectedRelease.id,
  );

  if (currentIndex === -1 || currentIndex === releases.length - 1) {
    return null;
  }

  const previousRelease = releases[currentIndex + 1];
  if (!previousRelease) return null;

  return {
    release: previousRelease,
    releaseNumber: previousRelease.majorVersion,
  };
}

export function findDuplicateDocumentRelease({
  releases,
  title,
  categoryId,
}: {
  releases: DocumentReleaseSummary[] | undefined;
  title: string;
  categoryId: number | null;
}): DocumentReleaseSummary | undefined {
  if (!releases || categoryId === null) return undefined;
  const normalizedTitle = title.trim().toLowerCase();
  if (!normalizedTitle) return undefined;
  return releases.find(
    (release) =>
      release.document.category.id === categoryId &&
      release.artifact.status !== DocumentArtifactStatus.archived &&
      release.artifact.title.trim().toLowerCase() === normalizedTitle,
  );
}
